export default __webpack_public_path__ + "static/media/AWSLambda.c0861ba6.svg";